import React from "react";
import { string, object } from "prop-types";

const SupportTeamImage = (props) => {
  const { src, alt, style } = props;

  return (
    <div className="support-team-image" style={style}>
      <img
        src={src}
        alt={alt}
        height="45px"
        width="45px"
        style={{ border: "1px solid #fff", borderRadius: "50%" }}
      />
    </div>
  );
};

SupportTeamImage.propTypes = {
  src: string.isRequired,
  alt: string.isRequired,
  style: object.isRequired,
};

export default SupportTeamImage;
